module.exports = __webpack_public_path__ + "img/convenio-de-practicas10.e54ff377.png";